export default __webpack_public_path__ + "static/media/Rudolph.072b0440.mp3";